import { FilterProvider } from "@/dashboard/search/context/FilterContext.tsx";
import { registerAppProvider } from "@/shared/bootstrap/react.tsx";

registerAppProvider(FilterProvider);
